import React, { forwardRef } from 'react'
import { CFCDN } from './ProductCollection'
import { ProductCardType } from './ProductCollection'
import { useNavigate } from 'react-router-dom'


interface ProductCardFormProps {
    index: number;
    aspect:string;
    item : ProductCardType
    
  }

const ProductCard= forwardRef((props: ProductCardFormProps, ref) => {
    const { index,aspect, item } = props;
    const navigate = useNavigate()
    return (
        <div key={index} className='flex  flex-col w-full hedvig-letters-sans-regular '>
            <div className={`w-full ${aspect} overflow-hidden  border-none bg-white rounded-md my-auto overflow-hidden shadow-md hover:-translate-y-1 duration-300 transition-all`}
                onClick={()=>{navigate(item.page)}}
            >
                <img
                    src={item.cover}
                    alt="Centered Image"
                    className="w-full h-full transform object-cover object-center"
                /> 
            </div>
            <div className='w-full flex flex-col my-1 mx-2 h-full mt-5'>
                <span className='text-lg truncate hover:text-clip'>
                    {item.name}
                </span>
                <span className='inline-block text-base text-neutral-500 truncate hover:text-clip'>
                    {item.tagLine}
                </span> 
                <div className='h-full w-full flex items-end gap-5'>
                    <button 
                        className="transform text-black text-base p-1 mt-2 bg-neutral-200 rounded-lg border-solid border-neutral-200 hover:text-black hover:bg-neutral-300 hover:border-solid hover:border-neutral-300 transition-transform duration-300 w-fit hover:translate-x-1"
                        onClick={()=>{navigate(item.page)}}
                    >
                        Buy Now
                    </button>
                    <span 
                        className="transform text-neutral-700 text-base p-1 mt-2 bg-transparent rounded-lg  w-fit"
                    >
                        From ${item.start}
                    </span>
                </div>
            </div>
        </div>
                
    )
});

  
ProductCard.displayName = 'ProductCard';
export default ProductCard;